const agingVisual = (e) => {
    const ct = `${e.category}:`;
    const vt = `${kendo.format('{0:C2}', e.value)}`;
    const ds = e.rect.origin;
    const labels = new kendo.drawing.Group();

    // console.log(ds.x < 0, ds.x);

    const pos1 = e.rect.origin;
    const pos2 = [e.rect.origin.x, e.rect.origin.y + 15];
    labels.append(new kendo.drawing.Text(ct, pos1, {font: 'bold .75em "Open Sans", sans-serif'}));
    labels.append(new kendo.drawing.Text(vt, pos2, {font: '.75em "Open Sans", sans-serif'}));

    return labels;
}

function setVisual(chart) {
    if (chart) {
        chart.options.series[0].labels.visual = agingVisual;
        chart.redraw();
    }
}

export const pieChartVisuals = () => {
    const arChart = $('#ArAging').data('kendoChart');
    const apChart = $('#ApAging').data('kendoChart');
    setVisual(arChart);
    setVisual(apChart);
};

export default function () {
    pieChartVisuals();
};